import { input, inject, computed, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SVG_SPRITE_URL } from './svg-icon.tokens';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'svg[icon]',
  template: '<svg:use [attr.href]="href()"></svg:use>',
  styleUrl: './svg-icon.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'svg-icon',
  },
})
export class SvgIcon {
  private readonly spriteUrl = inject(SVG_SPRITE_URL, { optional: true });

  public readonly icon = input.required<string>();

  protected readonly href = computed(() => `${this.spriteUrl}#${this.icon()}`);
}
